<template>
    <div>
        <a v-bind:href="url">
            <button
                class="btn btn-primary btn-sm"
                data-toggle="tooltip"
                data-placement="top"
                >
                <i class="glyphicon glyphicon-download"></i>
            </button>
        </a>
    </div>
</template>
<script>
    import config from '../../config'
    export default {
        props: {
            data: String
        },
        data () {
            let token = this.$store.state.token
            token = token.replace('Bearer ', '')
            return {
                url: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + this.$parent.$parent.type + '/' + this.data + '?token=' + token
            }
        },
        mounted () {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// ListSampleAction.vue?3dd974aa